import React from 'react'
// import { Link } from 'react-router-dom'
function SocialItem ({list}) {
    return (
        list.map((item, index) => {
            return (
                <li key={index}>
                    {
                        // item.target === '_blank'? (
                        <a href={item.toUrl} target={item.target}>
                            <div className="title lx-text-center lx-fz22 lx-fw600 lx-mt10 lx-mb25">{ item.title }</div>
                            <div className="cover-wrap lx-flex-row-center lx-hidden lx-fz0">
                                <img className="lx-w100" src={item.imgUrl} alt="cover" />
                            </div>
                            {/* <div className="content lx-fz14">{ item.content }</div> */}
                        </a>
                        // ): (
                        //     <Link to={item.toUrl}>
                        //         <div className="title lx-text-center lx-fz22 lx-fw600 lx-mt10 lx-mb25">{ item.title }</div>
                        //         <div className="cover-wrap lx-flex-row-center lx-hidden lx-fz0">
                        //             <img className="lx-h100" src={item.imgUrl} alt="cover" />
                        //         </div>
                        //         {/* <div className="content lx-fz14">{ item.content }</div> */}
                        //     </Link>
                        // )
                    }
                </li>
            )
        })
    ) 
}

export default SocialItem;